<div class="detail-item milestone-phase-item">
  @if (showIcon) {
    <div class="detail-icon">
      <mat-icon>event</mat-icon>
    </div>
  }
  <div class="detail-content">
    <span class="detail-label">{{ labelText }}</span>
    <span class="detail-value">
      {{ nearestMilestonePhase?.name || 'No milestone ' }}
      <!-- Additional milestone count badge -->
      @if (nearestMilestonePhase && nearestMilestonePhase.additionalCount && nearestMilestonePhase.additionalCount > 0) {
        <span class="additional-milestone-count"
          (mouseenter)="showMilestoneTooltip = true"
          (mouseleave)="showMilestoneTooltip = false">
          +{{ nearestMilestonePhase.additionalCount }}
          @if (showMilestoneTooltip) {
            <div class="milestone-tooltip-overlay">
              <div class="milestone-tooltip-container">
                <h4 class="tooltip-header">Other In-Progress Milestones</h4>
                <div class="milestone-cards">
                  @for (milestone of nearestMilestonePhase?.additionalMilestones; track milestone) {
                    <div class="milestone-card">
                      <div class="milestone-card-header">
                        <mat-icon class="milestone-icon">flag</mat-icon>
                        <span class="milestone-name">{{ milestone.name }}</span>
                      </div>
                      <div class="milestone-progress-info">
                        <span class="progress-text">{{ milestone.progress }}% Complete</span>
                        @if (milestone.task_count) {
                          <span class="task-count">
                            ({{ milestone.completed_task_count }}/{{ milestone.task_count }} tasks)
                          </span>
                        }
                      </div>
                      <div class="milestone-progress-bar">
                        <div class="progress-bar-container">
                          <div class="progress-bar-fill"
                            [style.width.%]="milestone.progress"
                            [ngClass]="'progress-in-progress'">
                          </div>
                        </div>
                      </div>
                      @if (milestone.due_date) {
                        <div class="milestone-due-date">
                          <mat-icon class="date-icon">calendar_today</mat-icon>
                          <span>Due: {{ milestone.due_date | date:'MMM dd, yyyy' }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </span>
      }
    </span>
    <!-- <span class="detail-extra">
    {{ formatStatus(nearestMilestonePhase?.status) }}
    <span *ngIf="nearestMilestonePhase"> • {{ nearestMilestonePhase.progress || 0 }}%</span>
  </span> -->
  <!-- Progress bar for milestone phase -->
  @if (nearestMilestonePhase) {
    <div class="milestone-progress-bar">
      <div class="progress-bar-container">
        <div class="progress-bar-fill"
          [style.width.%]="nearestMilestonePhase.progress || 0"
             [ngClass]="{
               'progress-completed': nearestMilestonePhase.status === 'completed',
               'progress-in-progress': nearestMilestonePhase.status === 'in_progress' || nearestMilestonePhase.status === 'in-progress',
               'progress-pending': nearestMilestonePhase.status === 'pending'
             }">
        </div>
      </div>
    </div>
  }
</div>
</div>

<!-- Hidden container for ProjectTimelineActivityComponent -->
<div style="display: none;">
  <ng-content></ng-content>
</div>